/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface NamedNumericValueDto
 */
export interface NamedNumericValueDto {
    /**
     * 
     * @type {string}
     * @memberof NamedNumericValueDto
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NamedNumericValueDto
     */
    value: number;
    /**
     * 
     * @type {string}
     * @memberof NamedNumericValueDto
     */
    $type?: NamedNumericValueDtoTypeEnum;
}


/**
 * @export
 */
export const NamedNumericValueDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedResultsDtoNamedNumericValueDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.NamedNumericValueDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type NamedNumericValueDtoTypeEnum = typeof NamedNumericValueDtoTypeEnum[keyof typeof NamedNumericValueDtoTypeEnum];



/**
 * Check if a given object implements the NamedNumericValueDto interface.
 */
export function instanceOfNamedNumericValueDto(value?: unknown): value is NamedNumericValueDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(NamedNumericValueDtoTypeEnum)[0];
}

export function NamedNumericValueDtoFromJSON(json: any): NamedNumericValueDto {
    return NamedNumericValueDtoFromJSONTyped(json, false);
}

export function NamedNumericValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NamedNumericValueDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'value': json['value'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function NamedNumericValueDtoToJSON(value?: NamedNumericValueDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'name': value['name'],
        'value': value['value'],
        '$type': value['$type'],
    });
}

